function isMobile() {
  let windowWidth = window.innerWidth;
  if(windowWidth < 769) {
      return true
  } else {
      return false;
  }
}

const debounce = (f, delay) => {
  let timer = 0;
  return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => f.apply(this, args), delay);
  }
}

function initBlogTagBars(scope = document) {
  scope.querySelectorAll('.blog-tag-bar').forEach(bar => {
    const list = bar.querySelector('ul');
    const activeTag = bar.querySelector('a.active');
    if (!list || !activeTag || list.scrollWidth <= list.clientWidth) return;

    requestAnimationFrame(() => {
      const centeredPosition = activeTag.offsetLeft - ((list.clientWidth - activeTag.offsetWidth) / 2);
      list.scrollLeft = Math.max(0, centeredPosition);
    });
  });
}

// PDP descriptions are also inserted by the cached "also available" product swap.
// Keep their setup outside DOMContentLoaded so it can be rerun for each new section.
let customPdpAccordionCount = 0;
const descriptionReadMoreObservers = new WeakMap();
const okendoResponsiveLinkCleanups = new WeakMap();
const klaviyoBackInStockCleanups = new WeakMap();
const customSliderCleanups = new WeakMap();

function initCustomPdpTabs(scope = document) {
  scope.querySelectorAll('.product-single__description').forEach(description => {
    const display = description.querySelector('.description--display');
    if (!display) return;
    if (display.dataset.customPdpTabsInitialized === 'true') return;

    const accordionIdPrefix = `custom-pdp-accordion-${customPdpAccordionCount++}`;
    const source = description.previousElementSibling;

    if (source && source.classList.contains('description')) {
      const tabs = source.querySelectorAll('.tabs li a');
      const content = source.querySelectorAll('.tabs-content > li');
      const itemCount = Math.min(tabs.length, content.length);

      if (itemCount) {
        let html = '';
        for (let i = 0; i < itemCount; i++) {
          const accordionId = `${accordionIdPrefix}-${i}`;
          html += `<button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders-top collapsible--auto-height" aria-controls="${accordionId}">${tabs[i].innerHTML}<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"/></svg>
            </span></button>`;
          html += `<div id="${accordionId}" class="collapsible-content collapsible-content--all"><div class="collapsible-content__inner rte">${content[i].innerHTML}</div></div>`;
        }

        display.innerHTML = html;
      }
    }

    display.querySelectorAll('.collapsible-trigger').forEach((trigger, index) => {
      const panel = trigger.nextElementSibling;
      if (!panel || !panel.classList.contains('collapsible-content')) return;

      const accordionId = `${accordionIdPrefix}-${index}`;
      trigger.setAttribute('aria-controls', accordionId);
      panel.id = accordionId;
    });

    display.dataset.customPdpTabsInitialized = 'true';
    if (theme.collapsibles) theme.collapsibles.init(display);
  });
}

function refreshDescriptionCollapsibleHeight(outer) {
  const panel = outer.closest('.collapsible-content');
  if (!panel || !panel.classList.contains('is-open')) return;
  panel.style.height = outer.offsetHeight + 'px';
}

function measureDescriptionReadMore(outer) {
  const box = outer.querySelector('.description-read-more');
  const btn = outer.querySelector('.description-read-more__expand');
  if (!box || !btn || outer.classList.contains('description-read-more-outer--expanded')) return;

  const panel = outer.closest('.collapsible-content');
  if (panel && !panel.classList.contains('is-open')) {
    box.classList.remove('description-read-more--clamp');
    btn.hidden = true;
    return;
  }

  box.classList.add('description-read-more--clamp');
  const overflowing = box.scrollHeight > box.clientHeight + 2;
  if (overflowing) {
    btn.hidden = false;
  } else {
    box.classList.remove('description-read-more--clamp');
    btn.hidden = true;
  }
}

function initPdpDescriptionReadMore(scope = document) {
  scope.querySelectorAll('.description-read-more-outer').forEach(outer => {
    outer.classList.remove('description-read-more-outer--init');

    const box = outer.querySelector('.description-read-more');
    const btn = outer.querySelector('.description-read-more__expand');
    if (!box || !btn) return;

    const runMeasure = () => measureDescriptionReadMore(outer);
    requestAnimationFrame(runMeasure);

    if (outer.dataset.descriptionReadMoreInitialized === 'true') return;
    outer.dataset.descriptionReadMoreInitialized = 'true';

    btn.addEventListener('click', () => {
      outer.classList.add('description-read-more-outer--expanded');
      box.classList.remove('description-read-more--clamp');
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => refreshDescriptionCollapsibleHeight(outer));
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => requestAnimationFrame(runMeasure));
      observer.observe(outer);
      descriptionReadMoreObservers.set(outer, observer);
    }
  });
}

function destroyPdpDescriptionReadMore(scope) {
  scope.querySelectorAll('.description-read-more-outer').forEach(outer => {
    const observer = descriptionReadMoreObservers.get(outer);
    if (!observer) return;

    observer.disconnect();
    descriptionReadMoreObservers.delete(outer);
  });
}

function initOkendoResponsiveLinks(scope = document) {
  scope.querySelectorAll('#okendo-responsive-link').forEach(anchor => {
    if (okendoResponsiveLinkCleanups.has(anchor)) return;

    const mobileMedia = window.matchMedia('(max-width: 768px)');
    const productSection = anchor.closest('.product-section[data-section-type="product"]');
    const productTabSelector = '[aria-controls="Product-content-oke-widget-pdp-tab-mobile"]';

    const updateAnchorLink = event => {
      anchor.href = event.matches
        ? '#Product-content-oke-widget-pdp-tab-mobile'
        : '#oke-widget-pdp';
    };

    const handleAnchorClick = event => {
      if (!mobileMedia.matches) return;

      event.preventDefault();
      const searchScope = productSection || document;
      const target = searchScope.querySelector(productTabSelector);
      if (!target) return;

      if (target.getAttribute('aria-expanded') === 'false') target.click();

      const panel = searchScope.querySelector('#Product-content-oke-widget-pdp-tab-mobile');
      if (panel) requestAnimationFrame(() => panel.scrollIntoView({ behavior: 'smooth' }));
    };

    anchor.addEventListener('click', handleAnchorClick);
    mobileMedia.addEventListener('change', updateAnchorLink);
    updateAnchorLink(mobileMedia);

    okendoResponsiveLinkCleanups.set(anchor, () => {
      anchor.removeEventListener('click', handleAnchorClick);
      mobileMedia.removeEventListener('change', updateAnchorLink);
    });
  });
}

function destroyOkendoResponsiveLinks(scope) {
  scope.querySelectorAll('#okendo-responsive-link').forEach(anchor => {
    const cleanup = okendoResponsiveLinkCleanups.get(anchor);
    if (cleanup) cleanup();
    okendoResponsiveLinkCleanups.delete(anchor);
  });
}

function initProductCalloutSliders(scope) {
  scope.querySelectorAll('.product-custom-callout.custom-slider').forEach(slider => {
    initCustomSlider(slider);
  });
}

function destroyProductCalloutSliders(scope) {
  scope.querySelectorAll('.product-custom-callout.custom-slider').forEach(slider => {
    const cleanup = customSliderCleanups.get(slider);
    if (cleanup) cleanup();
    customSliderCleanups.delete(slider);
  });
}

function hydrateProductInventory(section) {
  const inventoryData = section.querySelector('.js-product-inventory-data');
  if (!inventoryData) return;

  const productId = inventoryData.dataset.productId;
  if (!productId) return;

  window.inventories = window.inventories || {};
  window.inventories[productId] = {};

  inventoryData.querySelectorAll('.js-variant-inventory-data').forEach(variant => {
    window.inventories[productId][variant.dataset.id] = {
      quantity: variant.dataset.quantity,
      policy: variant.dataset.policy,
      incoming: variant.dataset.incoming === 'true',
      next_incoming_date: variant.dataset.date
    };
  });
}

function getProductVariants(section) {
  const variantsJson = section.querySelector('[data-variant-json]');
  if (!variantsJson) return [];

  try {
    return JSON.parse(variantsJson.value || variantsJson.textContent);
  } catch (error) {
    console.log(error);
    return [];
  }
}

function getCurrentProductVariant(section) {
  const variants = getProductVariants(section);
  if (!variants.length) return null;

  const masterSelect = section.querySelector('[data-product-select]');
  const selectedId = masterSelect && Number.parseInt(masterSelect.value, 10);
  if (selectedId) {
    const selectedVariant = variants.find(variant => variant.id === selectedId);
    if (selectedVariant) return selectedVariant;
  }

  const selectedOptions = [...section.querySelectorAll('[data-variant-input]')]
    .filter(input => input.tagName === 'SELECT' || input.checked)
    .map(input => input.value);
  const optionMatch = variants.find(variant => {
    return selectedOptions.length && selectedOptions.every((value, index) => variant.options[index] === value);
  });

  return optionMatch || variants[0];
}

function buildProductVariantUrl(url, variantId) {
  const variantUrl = new URL(url, window.location.href);
  if (variantId) variantUrl.searchParams.set('variant', variantId);
  return variantUrl.href;
}

function initKlaviyoBackInStockFallback(section, url) {
  if (!theme.settings.klaviyoBackInStockEnabled || theme.settings.klaviyoBackInStockUsesCustom) return;

  const handleVariantChange = event => {
    const variant = event.detail && event.detail.variant;
    if (!variant || variant.available || section.dataset.klaviyoBisNavigating === 'true') return;

    section.dataset.klaviyoBisNavigating = 'true';
    window.location.assign(buildProductVariantUrl(url, variant.id));
  };

  section.addEventListener('variantChange', handleVariantChange);
  klaviyoBackInStockCleanups.set(section, () => {
    section.removeEventListener('variantChange', handleVariantChange);
  });
}

function destroyKlaviyoBackInStockFallback(section) {
  const cleanup = klaviyoBackInStockCleanups.get(section);
  if (cleanup) cleanup();
  klaviyoBackInStockCleanups.delete(section);
}

// Show/Hide collection filters
jQuery(document).on( "click", '.js-hide-filters', function(e) {
    const el = e.target;
    const action = el.dataset.action;
    const collectionWrapper = document.querySelector('#CollectionAjaxContent');
    const textEl = el.querySelector('span');
    if(action === "hide") {
        collectionWrapper.classList.add('filters-hidden');
        el.setAttribute('data-action', "show");
        textEl.textContent = "Show Filter";
    } else {
        collectionWrapper.classList.remove('filters-hidden');
        el.setAttribute('data-action', "hide");
        textEl.textContent = "Hide Filter";
    }
    if (window.AOS) { AOS.refreshHard() }
});

// Show social share icons
jQuery(document).on( "click", '.js-show-social-share', function(e) {
  const el = e.target;
  const socialShareEl = document.querySelector('.social-share-icons');
  socialShareEl.classList.remove('hidden');
  el.classList.add('hide');
});


// Load more items
class LoadMore extends HTMLElement {
  constructor(){
    super();

    this.action = this.dataset.action;
    this.baseUrl = this.dataset.url;
    this.totalPages = +this.dataset.totalPages;
    this.currentPage = +this.dataset.currentPage;
    const gridScope = this.closest('#CollectionAjaxContent, #SearchspringFallbackContent, .collection-content');
    const scopedGridTarget = gridScope && gridScope.querySelector(this.dataset.gridTarget);
    this.gridTarget = scopedGridTarget || document.querySelector(this.dataset.gridTarget);
    this.gridTargetClass = this.dataset.gridTarget;
    this.gridItemTargetClass = this.dataset.gridItemTarget;
    this.paginateOffset = parseInt(this.dataset.paginateOffset);
    this.numberOfPromos = parseInt(this.dataset.numberOfPromos);

    if(this.paginateOffset > 0) {
      this.hideOffsetItems(true);
    }

    this.renderBtn();
  }

  renderBtn() {
    let showBtn = false;

    if(this.action === "next" && this.totalPages > this.currentPage) {
      showBtn = true;
    }

    if(this.action === "previous" && this.currentPage !== 1) {
      showBtn = true;
    }

    if(showBtn) {
      let btnHtml = `
        <div class="load-more-wrap text-center">
          <button type="button" class="btn btn--small">Load ${this.action === "next" ? "More" : "Previous"}</button>
        </div>
      `;
      this.innerHTML = btnHtml;
      this.registerBtnEvtListener();
    }
  }

  registerBtnEvtListener() {
    const btn = this.querySelector('.btn');
    btn.addEventListener('click', (e) => {
      this.fetchItems(e.target);
    })
  }

  getCurrentUrl() {
    let queryString = window.location.search;

    if(queryString) {
      const urlParams = new URLSearchParams(queryString);
      if(urlParams.has('page')) {
        queryString = queryString.replace(`page=${urlParams.get('page')}`, '[page]');
      }
      return this.baseUrl + queryString;
      
    } else {
      return this.baseUrl;
    }
  }

  async fetchItems(btn) {
    btn.classList.add('btn--loading');

    let currentUrl = this.getCurrentUrl();
    let newPage = this.currentPage;

    if(this.action === "next") {
      newPage = this.currentPage + 1;
    }

    if(this.action === "previous") {
      newPage = this.currentPage - 1;
    }

    if(currentUrl.includes('[page]')) {
      currentUrl = currentUrl.replace('[page]', 'page=' + newPage);
    } else if(currentUrl.includes('?')) {
      currentUrl = currentUrl +'&page='+newPage;
    } else {
      currentUrl = currentUrl +'?page='+newPage;
    }

    try {
      const res = await fetch(currentUrl);
      const text = await res.text();

      if (res.ok) {
        this.renderItems(text);
      }
    } catch (error) {
      console.log(error);
    } finally {
      if((this.action === "next" && newPage >= this.totalPages) || (this.action === "previous" && newPage <= 1)) {
        btn.remove();
        this.reshowHiddenOffsetItems();
      } else {
        btn.classList.remove('btn--loading');
        if(this.paginateOffset > 0) {
          this.reshowHiddenOffsetItems();
          this.hideOffsetItems();
        }
      }
      this.updatePageCount(newPage);
      window.history.pushState({page: newPage}, "", currentUrl);
    }
  }

  reshowHiddenOffsetItems() {
      if (!this.gridTarget) {
        return;
      }

      const alreadyHidden = this.gridTarget.querySelectorAll(`${this.gridItemTargetClass}.hide`);
      if(alreadyHidden.length) {
        alreadyHidden.forEach(item => {
          item.classList.remove('hide');
        })
      }
    }

    hideOffsetItems(initial) {
        if (!this.gridTarget) {
          return;
        }

        let itemsToHide = this.gridTarget.querySelectorAll(`${this.gridItemTargetClass}:nth-last-child(-n+${this.paginateOffset})`);
        if(initial) {
            const numberToOffset = this.paginateOffset + this.numberOfPromos;
            itemsToHide = this.gridTarget.querySelectorAll(`${this.gridItemTargetClass}:nth-last-child(-n+${numberToOffset})`);
        }
        
        if(itemsToHide.length) {
            itemsToHide.forEach(item => {
                item.classList.add('hide');
            })
        }
    }

  updatePageCount(newPage) {
    this.currentPage = newPage;
    this.setAttribute('data-current-page', newPage);
  }

  parseProductHTML(text) {
    const html = document.createElement('div');
    html.innerHTML = text;
    const items = html.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`);

    if (items.length) {
      return {
        items: items
      }
    }

    const fallbackTemplate = html.querySelector('#SearchspringFallbackTemplate');
    const fallbackItems = fallbackTemplate && fallbackTemplate.content
      ? fallbackTemplate.content.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`)
      : [];

    return {
      items: fallbackItems
    }
  }

  renderItems(text) {
    const markup = this.parseProductHTML(text);
    if(this.action === "next") {
      this.gridTarget.append(...markup.items);
    }
    if(this.action === "previous") {
      this.gridTarget.prepend(...markup.items);
    }

    if (window.AOS) { AOS.refreshHard() }
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  }
}

if (!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore);
}

// Product grid size selector
class ProductSizes extends HTMLElement {
  constructor(){
    super();

    this.showSizesBtn = this.querySelector('.js-open-size-selector');
    this.closeSizesBtn = this.querySelector('.js-close-size-selector');
    this.sizeContainer = this.querySelector('.grid-item-custom__size-selectors');
    this.sizeAtcBtns = this.querySelectorAll('.grid-item-custom__size-swatch');

    // Track which buttons have listeners attached
    this.sizeBtnHandlers = new WeakMap();

    this.initEvtListeners();
  }

  initEvtListeners() {
    if(this.showSizesBtn) {
      this.showSizesBtn.addEventListener('click', (e) => {
        const isOpenText = e.target.dataset.open;
        const isOpen = isOpenText == "true";
        if(isOpen) {
          this.sizeContainer.classList.add('hidden');
          e.target.classList.remove('hide');
          e.target.setAttribute('data-open', "false");
        } else {
          this.sizeContainer.classList.remove('hidden');
          e.target.classList.add('hide');
          e.target.setAttribute('data-open', "true");
        }
      })
    }

    if(this.closeSizesBtn) {
      this.closeSizesBtn.addEventListener('click', (e) => {
        this.sizeContainer.classList.add('hidden');
        e.target.classList.remove('hide');
        if(this.showSizesBtn) {
          this.showSizesBtn.classList.remove('hide');
          this.showSizesBtn.setAttribute('data-open', "false");
        }
      })
    }

    this.addSizeEventListener();

    if (!this._searchspringListenersAdded) {
      window.addEventListener('searchspring.domReady', this.initAfterSearchspringLoads.bind(this));
      window.addEventListener('searchspringCarousel.domReady', this.initAfterSearchspringLoads.bind(this));
      this._searchspringListenersAdded = true;
    }
  }

  initAfterSearchspringLoads() {
    this.showSizesBtn = this.querySelector('.js-open-size-selector');
    this.sizeAtcBtns = this.querySelectorAll('.grid-item-custom__size-swatch');
    this.closeSizesBtn = this.querySelector('.js-close-size-selector');
    this.sizeContainer = this.querySelector('.grid-item-custom__size-selectors');
    this.addSizeEventListener();
  }

  addSizeEventListener() {
    if(this.sizeAtcBtns.length) {
      this.sizeAtcBtns.forEach(btn => {
         // Remove existing listener if one exists
        const existingHandler = this.sizeBtnHandlers.get(btn);
        if (existingHandler) {
           btn.removeEventListener('click', existingHandler);
        }
         
         // Create and store the handler function
        const clickHandler = (e) => {
          const id = e.target.dataset.variant;
          const btn = e.target;
          this.addProductToCart(btn, id);
        };

        // Store the handler reference
        this.sizeBtnHandlers.set(btn, clickHandler);
        
        // Add the new listener
        btn.addEventListener('click', clickHandler);
      })
    }
  }

  async addProductToCart(btn, id) {
    // id = +id;
    btn.classList.add('btn--loading');
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            { id, quantity: 1 }
          ]
        })
      });
      const data = await res.json();

      if (res.ok){
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));
        
      }
      if (res.status === 422) {
        this.error(data);
      }
    } catch (error) {
      this.error(error);
    } finally {
      btn.classList.remove('btn--loading');
      this.sizeContainer.classList.add('hidden');
      if(this.showSizesBtn) {
        this.showSizesBtn.classList.remove('hide');
        this.showSizesBtn.setAttribute('data-open', "false");
      }
    }
  }

  static get observedAttributes() {
    return [
      'data-product',
    ];
  };

  attributeChangedCallback() {
    this.initAfterSearchspringLoads();
  }
}

if (!customElements.get('product-sizes')) {
  customElements.define('product-sizes', ProductSizes);
}

// PLP colour swatches
class colourSwatches extends HTMLElement {
  constructor(){
    super();

    this.query = this.dataset.query;
    if (!this.query) return;

    this.token = 'eefe1f53b218538b48d6a39de5a0adea';
    this.endpoint = theme.routes.storefrontAPI;
    this.data = '';

    this.init();
  }

  async init() {
    try {
      const res = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'X-Shopify-Storefront-Access-Token': this.token,
          'Content-Type': 'application/graphql',
        },
        body: `{ 
          products(first: 200, query: "title:${this.query}*") {
            edges {
              node {
                id
                availableForSale
                title
                handle
                tags
                images(first: 2) {
                  edges {
                    node {
                      transformedSrc(maxWidth: 500)
                    }
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                      amount
                  }
                  minVariantPrice {
                      amount
                  }
                }
                priceRange {
                  maxVariantPrice {
                    amount
                  }
                  minVariantPrice {
                    amount
                  }
                }
                variants(first: 20) {
                  edges {
                    node {
                      availableForSale
                      title
                      id
                      selectedOptions {
                        name
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }`
      });

      const data = await res.json();

      if (res.ok) {
          this.data = data.data.products.edges;
          this.renderElements();
      }
    } catch (error) {
        console.log(error)
    }
  }

  renderElements() {
    let count = 0;
    let colourSwatchHtml = '';
    this.data.forEach(product => {
      const colour = product.node.title.split(' - ').pop().toLowerCase();
      const title = product.node.title.split(' - ').shift();
      if(colour && title === this.query) {
        if(count < 7) {
          const colourHandle = colour.replaceAll(' ', '-').replaceAll('/', '');
          const colourImage = this.dataset.fileStructure.replace('colour', `swatch-${colourHandle}`);
          const variants = [];
          product.node.variants.edges.forEach(variant => {
            variants.push({
              "id": variant.node.id,
              "available": variant.node.availableForSale,
              "title": variant.node.title,
              "selectedOptions": variant.node.selectedOptions
            })
          })
          colourSwatchHtml += `
            <button type="button" class="colour-swatch js-update-product" title="${colour}" style="background-image:url(${colourImage});">
            <span class="visually-hidden">${colour}</span>
            <script type="application/json">${JSON.stringify(product.node)}</script>
            </button>
          `;
        }
        count++;
      }
    })
    if( count > 7) {
      const countToShow = count - 7;
      const countEl = `
        <a href="${this.dataset.currentProductUrl}" class="colour-swatch-additional-colour">+${countToShow}</a>
      `;
      colourSwatchHtml += countEl;
    }
    if(count > 0) {
      const div = document.createElement('div');
      div.innerHTML = colourSwatchHtml;
      this.append(div);
      this.addSwatchChangeListener();
    }
  }

  addSwatchChangeListener() {
    const btns = this.querySelectorAll('.js-update-product');
    if(btns.length) {
      btns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const script = e.target.querySelector('script');
          const productData = script ? JSON.parse(script.textContent) : null;
          this.updateProduct(e, productData);
        })
      })
    }
  }

  async updateProduct(e, productData) {
    const parent = e.target.closest('.grid-product');
    parent.classList.add('product-updating');

    // Update images
    const images = parent.querySelectorAll('.grid-product__image-mask img');
    if(images[0] && productData.images.edges[0].node.transformedSrc) {
      images[0].removeAttribute("srcset");
      images[0].src = productData.images.edges[0].node.transformedSrc;
    }
    if(images[1] && productData.images.edges[1].node.transformedSrc) {
      images[1].removeAttribute("srcset");
      images[1].src = productData.images.edges[1].node.transformedSrc;
    }

    // Update product colour name
    const colourEl = parent.querySelector('.grid-product__colour');
    const colour = e.target.getAttribute('title');
    if(colour && colourEl) {
      colourEl.textContent = colour;
    }

    // Update tag content
    const tagListEl = parent.querySelector('.grid-product__taglist');
    const tags = productData.tags;
    if(tags && tagListEl) {
      let tagsToShow = theme.settings.productTagsToShow.split(',').map(tag => tag.trim());
      console.log(tagsToShow);
      tagsToShow = tags.filter(tag => tagsToShow.includes(tag));
      console.log(tagsToShow);
      tagsToShow = tagsToShow.join(', ');
      console.log(tagsToShow);
      const hasUnisex = tags.includes('Unisex') || tags.includes('unisex');
      if(hasUnisex) {
        if(tagsToShow != '' && tagsToShow != null) {
          tagsToShow = 'Unisex - ' + tagsToShow;
        } else {
          tagsToShow = 'Unisex';
        }
      }
      tagListEl.textContent = tagsToShow;
    }

    // Update sizes quick add
    const sizeEl = parent.querySelector('.grid-item-custom__size-selectors');
    const productSizeParent = parent.querySelector('product-sizes');
    let sizesHtml = '';
    if(sizeEl && productData.variants.edges.length > 0) {
      sizesHtml = `<div class="grid-item-custom__size-selectors-heading-wrapper">
        <div class="grid-item-custom__size-selectors-heading">Quick Add</div>
        <button type="button" class="js-close-size-selector product-grid__close-quick-add-btn inner-no-pointer-events medium-up--hide" data-open="true" aria-label="Close Size Selector">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7" stroke="#33363F" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L7 7" stroke="#33363F" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>`;
      let sizes = [];
      productData.variants.edges.forEach(variant => {
        const variantId = variant.node.id.split('/').pop();
        const sizeObject = variant.node.selectedOptions.find(({ name }) => name === "Size");
        if (sizeObject && !sizes.includes(sizeObject.value)) {
          sizesHtml += `
            <span class="grid-item-custom__size-swatch${ variant.node.availableForSale ? '' : ' grid-item-custom__size-swatch--disabled'}" data-variant="${variantId}">${sizeObject.value}</span>
          `;
          sizes.push(sizeObject.value);
        } else if(variant.node.selectedOptions.length === 1 && variant.node.selectedOptions[0].value === "Default Title") {
          sizesHtml += `
            <span class="grid-item-custom__size-swatch${ variant.node.availableForSale ? '' : ' grid-item-custom__size-swatch--disabled'}" data-variant="${variantId}">O/S</span>
          `;
        }
      });
      sizeEl.innerHTML = sizesHtml;
      productSizeParent.setAttribute('data-product', productData.id);
      const closeBtn = sizeEl.querySelector('.js-close-size-selector');
      closeBtn.addEventListener('click', (e) => {
        e.target.closest('.grid-item-custom__size-selectors').classList.add('hidden');
        const openBtn = sizeEl.closest('.grid-product').querySelector('.js-open-size-selector');
        openBtn.classList.remove('hide');
        openBtn.setAttribute('data-open', "false");
      });
    }

    // Update price
    const priceElement = parent.querySelector('.grid-product__price');
    let minPrice = productData.priceRange.minVariantPrice.amount;
    let maxPrice = productData.priceRange.maxVariantPrice.amount;
    let minCompareAtPrice = productData.compareAtPriceRange.minVariantPrice.amount;

    if(Shopify.currency.active != theme.settings.shopCurrency) {
      const url = window.location.origin + '/products/' + productData.handle + '.json';
      const accessToken = 'eefe1f53b218538b48d6a39de5a0adea';
      try {
          const res = await fetch(url, {
              method: "GET",
              headers: {
                  "Content-Type": "application/graphql",
                  "X-Shopify-Storefront-Access-Token": accessToken
              }
          });
          const data = await res.json();
  
          if (res.ok) {
              const variants = data.product.variants;
              let prices = variants.map(variant => variant.price);
              prices = prices.slice() // slice makes copy of array before sorting it
                  .sort(function(a,b){
                      return parseInt(a) > parseInt(b);
                  }).reverse()
                  .reduce(function(a,b){
                      if (a.slice(-1)[0] !== b) a.push(b); // slice(-1)[0] means last item in array without removing it (like .pop())
                      return a;
              },[]); // this empty array becomes the starting value for a

              let comparePrices = variants.map(variant => variant.compare_at_price);
              comparePrices = comparePrices.slice() // slice makes copy of array before sorting it
                  .sort(function(a,b){
                      return parseInt(a) > parseInt(b);
                  }).reverse()
                  .reduce(function(a,b){
                      if (a.slice(-1)[0] !== b) a.push(b); // slice(-1)[0] means last item in array without removing it (like .pop())
                      return a;
              },[]); // this empty array becomes the starting value for a
              minPrice = prices[0];
              maxPrice = prices[prices.length - 1];
              minCompareAtPrice = comparePrices[0];
          }
      }
      catch (err) {
          console.error(err);
      }
    }
    let onSale = false;
    if(parseInt(minCompareAtPrice) > parseInt(minPrice)) {
      onSale = true;
    }

    let priceHtml = '';

    if(minPrice !== maxPrice) {
      priceHtml += 'from';
    }
    priceHtml += `<span class="money">${theme.Currency.formatMoney(minPrice * 100, '${{amount_no_trailing_zeroes}}')}</span>${Shopify.currency.active == 'USD' ? 'USD' : ''}`;
    if(onSale) {
      priceHtml += `<span class="visually-hidden">Regular price</span><span class="grid-product__price--original"><span class="money">${theme.Currency.formatMoney(minCompareAtPrice * 100, '${{amount_no_trailing_zeroes}}')}</span>${Shopify.currency.active == 'USD' ? 'USD' : ''}</span>`;
      const percDiff = Math.abs(Math.round(((minCompareAtPrice * 100.0) - (minPrice * 100.0))) / (minCompareAtPrice * 1.0));
      priceHtml += `<span class="grid-product__price--savings">Save ${percDiff}%</span>`;
    }

    priceElement.innerHTML = priceHtml;

    // Update labels
    const labelWrapper = parent.querySelector('.grid-product__labels');
    let labelHtml = '';
    
    if(productData.tags.length) {
      productData.tags.forEach(tag => {
        if(tag.includes('_label:')) {
          const labelValue = tag.split('_label:').pop();
          labelHtml += `<div class="grid-product__tag grid-product__tag--custom">${labelValue}</div>`;
        }
      })
    }
    if(!productData.availableForSale) {
      labelHtml += '<div class="grid-product__tag grid-product__tag--sold-out">Sold out</div>';
    }
    if(onSale && productData.availableForSale) {
      const percDiff = Math.abs(Math.round(((minCompareAtPrice * 100.0) - (minPrice * 100.0))) / (minCompareAtPrice * 1.0));
      labelHtml += `<span class="grid-product__tag grid-product__tag--sale">${percDiff}% off</span>`;
    }
    if(labelWrapper) {
      labelWrapper.innerHTML = labelHtml;
    } else {
      const newWrapper = document.createElement('div');
      newWrapper.classList.add('grid-product__labels');
      newWrapper.innerHTML = labelHtml;
      const sizesWrapper = parent.querySelector('product-sizes');
      const parentWrapper = parent.querySelector('.grid-product__image-mask');
      if(sizesWrapper) {
        parentWrapper.insertBefore(newWrapper, sizesWrapper);
      } else {
        parentWrapper.append(newWrapper);
      }
    }

    // Update wishlist buttons
    const wishlistWrapper = parent.querySelector('.custom-wishlist-button-wrapper');
    const productId = productData.id.split('/').pop();
    const productUrl = theme.settings.shopSecureUrl + '/products/' + productData.handle;
    if(wishlistWrapper) {
      let wishlistHtml = `
        <button type="button" class="custom-wishlist-button" aria-label="Choose a variant to add to Wishlist" aria-expanded="false">
          <svg height="20px" viewBox="0 -960 960 960" width="20px" fill="#000" class="custom-wishlist">
              <path d="m480-197.85-22.31-20.38q-96.92-87.46-160-148.65-63.07-61.2-98.65-106.85-35.58-45.65-49.31-82.04Q136-592.15 136-629q0-71.31 49.85-121.15Q235.69-800 307-800q49.77 0 95 26t78 75.54Q512.77-748 558-774q45.23-26 95-26 71.31 0 121.15 49.85Q824-700.31 824-629q0 36.85-13.23 72.23-13.23 35.39-48.81 80.54-35.58 45.15-98.77 107.35Q600-306.69 500.31-216.23L480-197.85Zm0-43.15q93-83.77 153-142.65 60-58.89 95.5-102.39t49.5-77.11q14-33.62 14-65.85 0-59-40-99t-99-40q-35.77 0-66.65 15.27-30.89 15.27-69.81 55.11l-35 41h-3.08l-35-41q-39.69-40.61-71.19-55.5Q340.77-768 307-768q-58.23 0-98.62 40Q168-688 168-629q0 32.23 13 64.35 13 32.11 47.5 75.11t95 102Q384-328.54 480-241Zm0-264Z"/>
          </svg>
          <svg height="20px" viewBox="0 -960 960 960" width="20px" fill="#000" class="custom-wishlist-active">
              <path d="m480-197.85-22.31-20.38q-96.92-87.46-160-148.65-63.07-61.2-98.65-106.85-35.58-45.65-49.31-82.04Q136-592.15 136-629q0-71.31 49.85-121.15Q235.69-800 307-800q49.77 0 95 26t78 75.54Q512.77-748 558-774q45.23-26 95-26 71.31 0 121.15 49.85Q824-700.31 824-629q0 36.85-13.23 72.23-13.23 35.39-48.81 80.54-35.58 45.15-98.77 107.35Q600-306.69 500.31-216.23L480-197.85Z"/>
          </svg>
        </button>
        <div class="custom-wishlist-variant-list">
        `;
        productData.variants.edges.forEach(variant => {
          const variantId = variant.node.id.split('/').pop();
          wishlistHtml += `
            <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${productId} swym-button--custom-variant" data-swaction="addToWishlist" data-product-id="${productId}" data-variant-id="${variantId}" data-product-url="${productUrl}">${variant.node.title}</button>
          `;
        });
        wishlistHtml += '</div>';
        wishlistWrapper.innerHTML = wishlistHtml;
        const wishlistId = 'wishlist-' + productId + Date.now();
        parent.setAttribute("id", wishlistId);
        document.dispatchEvent(new CustomEvent("swatch-wishlist-update", {detail: wishlistId}));
    } else {
      const wishlistBtn = parent.querySelector('.swym-button');
      wishlistBtn.setAttribute("data-product-id", productId);
      wishlistBtn.setAttribute("data-variant-id", productData.variants.edges[0].node.id.split('/').pop());
      wishlistBtn.setAttribute("data-product-url", productUrl);
    }

    // Update product url
    const urlEls = parent.querySelectorAll('a');
    if(urlEls.length) {
      urlEls.forEach(urlEl => {
        const currentUrl = urlEl.getAttribute("href");
        const newUrl = currentUrl.split('/products/')[0] + '/products/' + productData.handle;
        urlEl.setAttribute("href", newUrl);
      });
    }
    setTimeout(() => {
      parent.classList.remove('product-updating');
    }, 1000);
  }
}

if (!customElements.get('colour-swatches')) {
  customElements.define('colour-swatches', colourSwatches);
}

class alsoAvailable extends HTMLElement {
  constructor(){
    super();

    this.hasInitialized = false;
  }

  connectedCallback() {
    if (this.hasInitialized) return;

    this.query = this.dataset.query;
    if (!this.query) return;

    this.graphqlQuery = this.query.replaceAll('\\', '\\\\').replaceAll('"', '\\"');
    this.id = this.dataset.id;
    this.token = 'eefe1f53b218538b48d6a39de5a0adea';
    this.endpoint = theme.routes.storefrontAPI;
    this.data = '';
    this.sectionCache = alsoAvailable.sectionCache || (alsoAvailable.sectionCache = {});
    this.productGroupCache = alsoAvailable.productGroupCache || (alsoAvailable.productGroupCache = {});
    this.hasInitialized = true;
    this.setAttribute('aria-busy', 'true');
    this.registerPopStateListener();
    this.cacheCurrentProductSection();
    this.init();
  }

  registerPopStateListener() {
    if (alsoAvailable.popStateListenerRegistered) return;

    window.addEventListener('popstate', () => {
      const activeSwatches = document.querySelector('also-available');
      if (activeSwatches && typeof activeSwatches.swapProductSection === 'function') {
        activeSwatches.swapProductSection(window.location.href, null, false);
      }
    });

    alsoAvailable.popStateListenerRegistered = true;
  }

  cacheCurrentProductSection() {
    const currentSection = this.closest('.product-section[data-section-type="product"]') || document.querySelector('.product-section[data-section-type="product"]');
    if (!currentSection || !currentSection.isConnected) return;

    const productUrl = this.getSectionProductUrl(currentSection);
    const cacheKey = this.getSectionCacheKey(productUrl, currentSection.dataset.sectionId);
    if (!this.sectionCache[cacheKey]) {
      this.sectionCache[cacheKey] = Promise.resolve(currentSection.outerHTML);
    }

    const reviewSection = this.getOkendoReviewSection();
    const reviewSectionId = this.getShopifySectionId(reviewSection);
    if (reviewSection && reviewSectionId) {
      const reviewCacheKey = this.getSectionCacheKey(productUrl, reviewSectionId);
      if (!this.sectionCache[reviewCacheKey]) {
        this.sectionCache[reviewCacheKey] = Promise.resolve(reviewSection.innerHTML);
      }
    }
  }

  getSectionProductUrl(section) {
    const sectionHandle = section.dataset.productHandle;
    if (!sectionHandle) return window.location.href;

    const locationUrl = new URL(window.location.href);
    const locationHandleMatch = locationUrl.pathname.match(/\/products\/([^/]+)/);
    if (locationHandleMatch && locationHandleMatch[1] === sectionHandle) return locationUrl.href;

    return this.getProductUrl(sectionHandle);
  }

  getOkendoReviewSection(scope = document) {
    const widget = scope.querySelector('#oke-widget-pdp');
    return widget ? widget.closest('[id^="shopify-section-"]') : null;
  }

  getShopifySectionId(section) {
    if (!section || !section.id || !section.id.startsWith('shopify-section-')) return '';
    return section.id.replace(/^shopify-section-/, '');
  }

  async init() {
    try {
      if (!this.productGroupCache[this.query]) {
        this.productGroupCache[this.query] = this.fetchProductGroup().catch(error => {
          delete this.productGroupCache[this.query];
          throw error;
        });
      }

      this.data = await this.productGroupCache[this.query];
      this.renderElements();
    } catch (error) {
        console.log(error)
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  async fetchProductGroup() {
    const res = await fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': this.token,
        'Content-Type': 'application/graphql',
      },
      body: `{
        products(first: 50, query: "title:${this.graphqlQuery}*") {
          edges {
            node {
              id
              availableForSale
              title
              handle
              featuredImage {
                transformedSrc(maxWidth: 190)
              }
            }
          }
        }
      }`
    });

    const data = await res.json();
    if (!res.ok) throw new Error('Also available product group request failed');

    return data.data.products.edges;
  }

  renderElements() {
    const products = this.data.filter(product => {
      const colour = product.node.title.split(' - ').pop().toLowerCase();
      const title = product.node.title.split(' - ').shift();
      return colour && title === this.query;
    });

    if (products.length <= 1) {
      this.replaceChildren();
      return;
    }

    const aaiHtml = products.map(product => {
      const colour = product.node.title.split(' - ').pop().toLowerCase();
      const image = product.node.featuredImage ? product.node.featuredImage.transformedSrc : '';
      const prodId = product.node.id.split('/').pop();
      const isActive = prodId === this.id;
      const imageHtml = image
        ? `<img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(product.node.title)}" width="95" height="119" loading="${isActive ? 'eager' : 'lazy'}" decoding="async">`
        : '';

      return `
        <a class="product-aai-swatch${isActive ? ' active' : ''}" href="${this.getProductUrl(product.node.handle)}" title="${this.escapeHtml(colour)}"${isActive ? ' aria-current="true"' : ''}>
          <span class="visually-hidden">${this.escapeHtml(colour)}</span>
          ${imageHtml}
        </a>
      `;
    }).join('');

    const wrapper = this.querySelector(':scope > .product-aai-swatches') || document.createElement('div');
    wrapper.classList.add('product-aai-swatches');
    wrapper.innerHTML = aaiHtml;
    if (!wrapper.isConnected) this.append(wrapper);
    this.addSwatchListeners(wrapper);
  }

  addSwatchListeners(scope) {
    scope.querySelectorAll('.product-aai-swatch').forEach(link => {
      link.addEventListener('click', event => this.handleSwatchClick(event, link));
    });
  }

  getProductUrl(handle) {
    const root = theme.routes && theme.routes.home ? theme.routes.home.replace(/\/$/, '') : '';
    return `${root}/products/${handle}`.replace('//', '/');
  }

  escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);
  }

  shouldHandleClick(event, link) {
    if (event.defaultPrevented) return false;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;

    const url = new URL(link.href, window.location.href);
    return url.origin === window.location.origin;
  }

  async handleSwatchClick(event, link) {
    if (!this.shouldHandleClick(event, link)) return;

    event.preventDefault();
    if (link.classList.contains('active')) return;

    await this.swapProductSection(link.href, link);
  }

  async swapProductSection(url, activeLink = null, updateHistory = true) {
    const currentSection = document.querySelector('.product-section[data-section-type="product"]');
    if (!currentSection) {
      window.location.href = url;
      return;
    }

    const requestId = (alsoAvailable.swapRequestId || 0) + 1;
    alsoAvailable.swapRequestId = requestId;
    const currentReviewSection = this.getOkendoReviewSection();

    currentSection.classList.add('product-section--swapping');
    this.setAttribute('aria-busy', 'true');
    if (activeLink) activeLink.classList.add('is-loading');

    try {
      const [nextSection, nextReviewSection] = await Promise.all([
        this.fetchProductSection(url, currentSection.dataset.sectionId),
        currentReviewSection
          ? this.fetchOkendoReviewSection(url, currentReviewSection)
          : Promise.resolve(null)
      ]);

      if (requestId !== alsoAvailable.swapRequestId) return;

      const selectedVariant = getCurrentProductVariant(nextSection);
      if (
        theme.settings.klaviyoBackInStockEnabled &&
        !theme.settings.klaviyoBackInStockUsesCustom &&
        selectedVariant &&
        !selectedVariant.available
      ) {
        window.location.assign(buildProductVariantUrl(url, selectedVariant.id));
        return;
      }

      this.unloadProductSection(currentSection);
      currentSection.replaceWith(nextSection);
      if (currentReviewSection && nextReviewSection) {
        currentReviewSection.replaceWith(nextReviewSection);
      }
      this.initProductSection(nextSection, url, nextReviewSection);

      if (updateHistory) {
        const nextUrl = new URL(url, window.location.href);
        window.history.pushState({ productUrl: nextUrl.href }, '', nextUrl.href);
      }
    } catch (error) {
      if (requestId !== alsoAvailable.swapRequestId) return;
      console.log(error);
      window.location.href = url;
    } finally {
      if (requestId === alsoAvailable.swapRequestId) this.removeAttribute('aria-busy');
      if (activeLink) activeLink.classList.remove('is-loading');
    }
  }

  async fetchProductSection(url, sectionId) {
    const requestUrl = new URL(url, window.location.href);
    const cacheKey = this.getSectionCacheKey(requestUrl.href, sectionId);

    if (!this.sectionCache[cacheKey]) {
      this.sectionCache[cacheKey] = this.fetchProductSectionHtml(requestUrl.href, sectionId).catch(error => {
        delete this.sectionCache[cacheKey];
        throw error;
      });
    }

    let html = await this.sectionCache[cacheKey];
    let section = this.parseProductSection(html, sectionId);

    if (!section) {
      this.sectionCache[cacheKey] = this.fetchProductPageHtml(url).catch(error => {
        delete this.sectionCache[cacheKey];
        throw error;
      });
      html = await this.sectionCache[cacheKey];
      section = this.parseProductSection(html, sectionId);
    }

    if (!section) throw new Error('Product section not found in response');
    return section;
  }

  getSectionCacheKey(url, sectionId) {
    const requestUrl = new URL(url, window.location.href);
    requestUrl.hash = '';
    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.delete('sections');

    return `${requestUrl.pathname}${requestUrl.search}|${sectionId}`;
  }

  async fetchProductSectionHtml(url, sectionId) {
    const requestUrl = new URL(url, window.location.href);
    requestUrl.searchParams.set('section_id', sectionId);

    const res = await fetch(requestUrl.href, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) throw new Error(`Product section request failed: ${res.status}`);
    return res.text();
  }

  async fetchProductPageHtml(url) {
    const res = await fetch(new URL(url, window.location.href).href, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) throw new Error(`Product page request failed: ${res.status}`);
    return res.text();
  }

  parseProductSection(htmlString, sectionId) {
    const html = document.createElement('div');
    html.innerHTML = htmlString;

    return html.querySelector(`.product-section[data-section-id="${sectionId}"]`) || html.querySelector('.product-section[data-section-type="product"]');
  }

  async fetchOkendoReviewSection(url, currentSection) {
    const sectionId = this.getShopifySectionId(currentSection);
    if (!sectionId) return null;

    const requestUrl = new URL(url, window.location.href);
    const cacheKey = this.getSectionCacheKey(requestUrl.href, sectionId);
    if (!this.sectionCache[cacheKey]) {
      this.sectionCache[cacheKey] = this.fetchProductSectionHtml(requestUrl.href, sectionId).catch(error => {
        delete this.sectionCache[cacheKey];
        throw error;
      });
    }

    let html = await this.sectionCache[cacheKey];
    let section = this.parseOkendoReviewSection(html, currentSection, sectionId);

    if (!section) {
      this.sectionCache[cacheKey] = this.fetchProductPageHtml(requestUrl.href).catch(error => {
        delete this.sectionCache[cacheKey];
        throw error;
      });
      html = await this.sectionCache[cacheKey];
      section = this.parseOkendoReviewSection(html, currentSection, sectionId);
    }

    if (!section) throw new Error('Okendo review section not found in response');
    return section;
  }

  parseOkendoReviewSection(htmlString, currentSection, sectionId) {
    const html = document.createElement('div');
    html.innerHTML = htmlString;

    const sectionSelector = `#shopify-section-${sectionId}`;
    const responseSection = html.querySelector(sectionSelector);
    const content = responseSection || html;
    if (!content.querySelector('#oke-widget-pdp')) return null;

    const nextSection = currentSection.cloneNode(false);
    nextSection.innerHTML = responseSection ? responseSection.innerHTML : htmlString;
    return nextSection;
  }

  unloadProductSection(section) {
    destroyPdpDescriptionReadMore(section);
    destroyOkendoResponsiveLinks(section);
    destroyProductCalloutSliders(section);
    destroyKlaviyoBackInStockFallback(section);

    if (!theme.sections || !Array.isArray(theme.sections.instances)) return;

    const sectionId = section.dataset.sectionId;
    theme.sections.instances = theme.sections.instances.filter(instance => {
      const isCurrentProduct = instance.id === sectionId && instance.type === 'product';

      if (isCurrentProduct && typeof instance.onUnload === 'function') {
        instance.onUnload();
      }

      return !isCurrentProduct;
    });
  }

  initProductSection(section, url, reviewSection = null) {
    hydrateProductInventory(section);

    if (theme.sections && theme.Product) {
      theme.sections.register('product', theme.Product, section.parentNode || document);
    }

    initCustomPdpTabs(section);
    initOkendoResponsiveLinks(section);
    initProductCalloutSliders(section);
    if (theme.initGlobals) theme.initGlobals();
    initPdpDescriptionReadMore(section);
    initKlaviyoBackInStockFallback(section, url);
    document.dispatchEvent(new CustomEvent('product:section:loaded', {
      detail: { section, url, reviewSection }
    }));
    this.refreshSearchspringRecommendations(section);
    this.trackSearchspringProductView(section);
    if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
    if (window.AOS) AOS.refreshHard();

    this.reinitializeOkendo(section);
    if (reviewSection) this.reinitializeOkendo(reviewSection);
    this.updateDocumentMetadata(section, url);
    this.reinitializeWishlist(section);
  }

  getProductRecommendationSeed(section) {
    const variantsJson = section.querySelector('[data-variant-json]');
    if (!variantsJson) return '';

    try {
      const variants = JSON.parse(variantsJson.value || variantsJson.textContent);
      return variants[0] && variants[0].sku ? variants[0].sku : '';
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  refreshSearchspringRecommendations(section) {
    const seed = this.getProductRecommendationSeed(section);
    if (!seed) return;

    const scripts = [...document.querySelectorAll('script[type="searchspring/personalized-recommendations"][profile]')]
      .filter(script => script.getAttribute('profile') !== 'recently-viewed');
    if (!scripts.length) return;

    scripts.forEach(script => {
      script.textContent = `seed = ${JSON.stringify(seed)};`;
    });

    const enqueueRefresh = () => {
      if (!window.searchspring || !window.searchspring.controller) return false;

      const controllers = Object.values(window.searchspring.controller);
      const matchingControllers = scripts.map(script => {
        const profile = script.getAttribute('profile');
        const controller = controllers.find(item => item && item.config && item.config.tag === profile);
        return controller && typeof controller.search === 'function' ? controller : null;
      }).filter(Boolean);
      const recommendations = [...new Set(matchingControllers)];
      if (!recommendations.length) return false;

      const refresh = async () => {
        const searches = recommendations.map(controller => {
          controller.config.globals = controller.config.globals || {};
          controller.config.globals.products = [seed];
          controller.context = controller.context || {};
          controller.context.seed = seed;
          if (controller.store && typeof controller.store.reset === 'function') {
            controller.store.reset();
          }

          return Promise.resolve(controller.search()).catch(error => console.log(error));
        });

        await Promise.all(searches);
        document.dispatchEvent(new CustomEvent('recommendations-loaded'));
      };

      alsoAvailable.searchspringRefreshQueue = Promise.resolve(alsoAvailable.searchspringRefreshQueue)
        .catch(error => console.log(error))
        .then(refresh);
      return true;
    };

    if (!enqueueRefresh()) {
      window.addEventListener('searchspring.domReady', enqueueRefresh, { once: true });
    }
  }

  trackSearchspringProductView(section) {
    const seed = this.getProductRecommendationSeed(section);
    const siteId = window.ss_site_id;
    if (!seed || !siteId || !window.IntelliSuggest) return;

    try {
      IntelliSuggest.init({ siteId, context: `Product/${seed}`, seed });
      IntelliSuggest.viewItem({ sku: seed });
    } catch (error) {
      console.log(error);
    }
  }

  updateDocumentMetadata(section, url) {
    const nextUrl = new URL(url, window.location.href);
    const canonical = document.querySelector('link[rel="canonical"]');

    if (canonical) {
      canonical.href = section.dataset.productUrl
        ? new URL(section.dataset.productUrl, window.location.origin).href
        : nextUrl.href;
    }
    if (section.dataset.productTitle) {
      const titleSuffix = document.title.includes(' – ') ? document.title.split(' – ').slice(1).join(' – ') : '';
      document.title = titleSuffix ? `${section.dataset.productTitle} – ${titleSuffix}` : section.dataset.productTitle;
    }
  }

  reinitializeOkendo(section) {
    const widgets = section.querySelectorAll('[data-oke-widget]');
    if (!widgets.length) return;

    const init = () => {
      if (!window.okeWidgetApi || typeof window.okeWidgetApi.initWidget !== 'function') return false;

      widgets.forEach(widget => {
        try {
          const result = window.okeWidgetApi.initWidget(widget, true);
          if (result && typeof result.catch === 'function') {
            result.catch(error => console.log(error));
          }
        } catch (error) {
          console.log(error);
        }
      });

      this.resizeOkendoWidgets(section);
      window.setTimeout(() => this.resizeOkendoWidgets(section), 250);
      return true;
    };

    if (!init()) {
      document.addEventListener('oke-script-loaded', () => init(), { once: true });
    }
  }

  resizeOkendoWidgets(section) {
    const widgets = section.querySelectorAll('.js-oke-widgetSize');
    if (!widgets.length) return;

    if (typeof window.okeSetWidgetSizes === 'function') {
      window.okeSetWidgetSizes(widgets);
    }

    if (window.okeResizeObserver && typeof window.okeResizeObserver.observe === 'function') {
      widgets.forEach(widget => window.okeResizeObserver.observe(widget));
    }
  }

  reinitializeWishlist(section) {
    const initialize = swat => {
      if (!swat || typeof swat.initializeActionButtons !== 'function') return false;

      const buttonBar = section.querySelector('.swym-wishlist-button-bar');
      if (!buttonBar) return true;

      const productId = section.dataset.productId;
      const productUrl = section.dataset.productUrl;
      const variantSelect = section.querySelector('[data-product-select]');
      let variantId = variantSelect ? variantSelect.value : '';

      if (!variantId) {
        const variantsJson = section.querySelector('[data-variant-json]');
        try {
          const variants = variantsJson ? JSON.parse(variantsJson.value || variantsJson.textContent) : [];
          variantId = variants[0] ? variants[0].id : '';
        } catch (error) {
          console.log(error);
        }
      }

      if (!productId || !productUrl || !variantId) return true;

      const container = document.createElement('div');
      container.className = 'swym-btn-container swym-inject';
      container.dataset.position = 'default';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = `swym-button swym-add-to-wishlist swym-add-to-wishlist-view-product swym-inject product_${productId}`;
      button.dataset.swaction = 'addToWishlist';
      button.dataset.withEpi = 'true';
      button.dataset.productId = productId;
      button.dataset.variantId = variantId;
      button.dataset.productUrl = new URL(productUrl, window.location.origin).href;
      button.setAttribute('aria-label', 'Add To Wishlist');

      const buttonText = document.createElement('span');
      buttonText.className = 'swym-wishlist-cta';
      buttonText.textContent = 'Add To Wishlist';
      button.append(buttonText);
      container.append(button);
      buttonBar.replaceChildren(container);

      const sectionId = window.CSS && CSS.escape ? CSS.escape(section.id) : section.id;
      swat.initializeActionButtons(
        `#${sectionId}`,
        '.swym-wishlist-button-bar [data-swaction]'
      );
      return true;
    };

    if (initialize(window._swat)) return;

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(swat => {
      window._swat = swat;
      initialize(swat);
    });
  }

}

if (!customElements.get('also-available')) {
  customElements.define('also-available', alsoAvailable);
}

// Custom sliders
const sliderReinitCallback = ([entry]) => {
  const flkty = Flickity.data(entry.target);
  if (flkty) flkty.resize();
}

const initMobileOnlySlider = (slider, args) => {
  let flickity;

  function initSlider() {
      if (flickity) return;
      flickity = new theme.Slideshow(slider, args);
  }

  function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
      flickity = null;
    }

  if (isMobile()) {
      initSlider();
  }

  const handleResize = function() {
      if(isMobile()) {
          initSlider();
      } else {
          unload();
      }
  };

  window.addEventListener('resize', handleResize, true);
  return () => {
    window.removeEventListener('resize', handleResize, true);
    unload();
  };
}

const initCustomSlider = (slider) => {
  if (!slider || customSliderCleanups.has(slider)) return;

  let args = slider.dataset.args;
  const mobileOnly = slider.dataset.mobileOnly;
  if(args) {
      args = JSON.parse(args);
  }
  if(slider.classList.contains('subcollections-grid')) {
    const flickity = new Flickity(slider, {
      pageDots: true, 
      prevNextButtons: true,
      cellAlign: "left",
      wrapAround: false,
      contain: true,
      groupCells: true,
      freeScroll: false,
      on: {
        change: function( index ) {
          const subcollectionGrid = document.querySelector('.subcollections-grid');
          subcollectionGrid.classList.add('show-page-dots');
        }
      }
    });
    customSliderCleanups.set(slider, () => flickity.destroy());
  } else {
    if(mobileOnly == "true") {
        customSliderCleanups.set(slider, initMobileOnlySlider(slider, args));
    } else {
        const flickity = new theme.Slideshow(slider, args);
        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(slider);
        customSliderCleanups.set(slider, () => {
          reinitFlickitySlider.disconnect();
          if (flickity && typeof flickity.destroy === 'function') flickity.destroy();
        });
    }
  }
}


const init = () => {

  // Animated search text
  function animateRotatingWords() {
    const animatedSearchTextElements = document.querySelectorAll('.animated-search-text');
    if (!animatedSearchTextElements.length) return;

    animatedSearchTextElements.forEach(animatedSearchText => {
      const rotatingWordsAttr = animatedSearchText.getAttribute('data-rotating-words');
      if (!rotatingWordsAttr) return;

      const rotatingWordsArray = rotatingWordsAttr.split(',').map(word => word.trim()).filter(word => word.length > 0);
      if (rotatingWordsArray.length === 0) return;

      const rotatingWordsContainer = animatedSearchText.querySelector('.animated-search-text-rotating-words');
      if (!rotatingWordsContainer) return;

      // Find the search input - it's a sibling in the same parent container
      const parentContainer = animatedSearchText.parentElement;
      const searchInput = parentContainer ? parentContainer.querySelector('.search__input') : null;
      
      let currentWordIndex = 0;
      let isAnimating = false;
      let animationTimeout = null;
      let isPaused = false;

      // Function to check if input has text and show/hide animated text
      function toggleAnimatedText() {
        if (!searchInput) return;
        
        const hasText = searchInput.value.trim().length > 0;
        
        if (hasText) {
          // Hide animated text
          animatedSearchText.style.display = 'none';
          isPaused = true;
          // Clear any pending animation timeouts
          if (animationTimeout) {
            clearTimeout(animationTimeout);
            animationTimeout = null;
          }
        } else {
          // Show animated text
          animatedSearchText.style.display = '';
          isPaused = false;
          // Resume animation if it was paused
          if (!isAnimating) {
            cycleWords();
          }
        }
      }

      // Function to reveal letters one at a time
      function revealWord(word, callback) {
        if (isAnimating || isPaused) return;
        isAnimating = true;
        
        rotatingWordsContainer.innerHTML = '';
        const letters = word.split('');
        let letterIndex = 0;

        function addNextLetter() {
          if (letterIndex < letters.length && !isPaused) {
            const span = document.createElement('span');
            span.textContent = letters[letterIndex];
            span.style.opacity = '0';
            rotatingWordsContainer.appendChild(span);
            
            // Trigger animation
            requestAnimationFrame(() => {
              span.style.transition = 'opacity 0.1s ease-in';
              span.style.opacity = '1';
            });
            
            letterIndex++;
            setTimeout(addNextLetter, 100); // Delay between letters
          } else {
            isAnimating = false;
            if (callback && !isPaused) callback();
          }
        }

        addNextLetter();
      }

      // Function to remove letters one at a time
      function removeWord(callback) {
        if (isAnimating || isPaused) return;
        isAnimating = true;

        const letters = rotatingWordsContainer.querySelectorAll('span');
        let letterIndex = letters.length - 1;

        function removeNextLetter() {
          if (letterIndex >= 0 && !isPaused) {
            const span = letters[letterIndex];
            span.style.transition = 'opacity 0.1s ease-out';
            span.style.opacity = '0';
            
            setTimeout(() => {
              span.remove();
            }, 100);
            
            letterIndex--;
            setTimeout(removeNextLetter, 50); // Delay between letters
          } else {
            isAnimating = false;
            if (callback && !isPaused) callback();
          }
        }

        removeNextLetter();
      }

      // Main animation cycle
      function cycleWords() {
        if (isPaused) return;
        
        const currentWord = rotatingWordsArray[currentWordIndex];
        
        // Reveal the current word
        revealWord(currentWord, () => {
          if (isPaused) return;
          
          // Wait a bit before removing
          animationTimeout = setTimeout(() => {
            if (isPaused) return;
            
            // Remove the word
            removeWord(() => {
              if (isPaused) return;
              
              // Move to next word
              currentWordIndex = (currentWordIndex + 1) % rotatingWordsArray.length;
              // Start next cycle
              animationTimeout = setTimeout(cycleWords, 200); // Small delay before next word
            });
          }, 2000); // Display time after full word is revealed
        });
      }

      // Set up event listeners for the search input
      if (searchInput) {
        // Check on input, focus, and blur events
        searchInput.addEventListener('input', toggleAnimatedText);
        searchInput.addEventListener('focus', toggleAnimatedText);
        searchInput.addEventListener('blur', toggleAnimatedText);
        
        // Initial check
        toggleAnimatedText();
      }

      // Add click handler to animated text to hide it and focus search input
      // Only if parent is not .fake-placeholder
      const isFakePlaceholder = parentContainer && parentContainer.classList.contains('fake-placeholder');
      
      if (!isFakePlaceholder) {
        animatedSearchText.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Hide the animated text
          animatedSearchText.style.display = 'none';
          isPaused = true;
          
          // Clear any pending animation timeouts
          if (animationTimeout) {
            clearTimeout(animationTimeout);
            animationTimeout = null;
          }
          
          // Focus the search input
          if (searchInput) {
            searchInput.focus();
          }
        });

        // Make animated text appear clickable (cursor pointer)
        animatedSearchText.style.cursor = 'text';
      }

      // Start the animation for this instance (only if not paused)
      if (!isPaused) {
        cycleWords();
      }
    });
  }

  animateRotatingWords();

  // Mobile menu slide
  const slideMenuBtns = document.querySelectorAll('.js-open-slide-menu');
  const mobileMenu = document.querySelector('.drawer--menu');
  if(slideMenuBtns.length) {
    slideMenuBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const self = e.target;
        const target = self.getAttribute('aria-controls');
        const currentActive = self.closest('.mobile-nav__slide-menu-item');
        const targetEl = mobileMenu.querySelector(`#${target}`);
        const direction = self.dataset.slide;
        currentActive.classList.remove('active');
        
        if(direction == "left") {
          currentActive.classList.add('was-active');
        } else {
          const wasActiveEls = document.querySelectorAll('.mobile-nav__slide-menu-item.was-active');
          if(wasActiveEls.length > 1) {
              wasActiveEls[wasActiveEls.length - 1].classList.remove('was-active');
          } else {
              wasActiveEls[0].classList.remove('was-active');
          }
        }
        targetEl.classList.add('active');
      })
    })
  }

  // Init additional currency disclosure
  const drawerCurrencySelector = document.querySelector('.drawer--menu [data-disclosure-currency]');
  if(drawerCurrencySelector) {
      new theme.Disclosure(drawerCurrencySelector);
  }

  const customSliders = document.querySelectorAll('.custom-slider');

  if(customSliders.length) {
    customSliders.forEach(slider => {
        initCustomSlider(slider);
    })
  }

  document.addEventListener('recommendations:loaded', (e) => {
    const recommendedProductSliders = document.querySelectorAll('.custom-slider--product');
    if(recommendedProductSliders.length) {
      recommendedProductSliders.forEach(slider => {
        initCustomSlider(slider);
      })
    }
  });

  // Smooth scroll to anchor
  const smoothScrollBtns = document.querySelectorAll('.js-smooth-scroll');
  if(smoothScrollBtns.length) {
    smoothScrollBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const elTarget = document.querySelector(e.target.getAttribute('href'));
        elTarget?.scrollIntoView({ behavior: "smooth"});
      })
    })
  }

  // Custom FAQ accordion
  const faqAccordions = document.querySelectorAll('.collapsible-trigger-custom');
  if(faqAccordions.length) {
    faqAccordions.forEach(accordion => {
      accordion.addEventListener('click', (e) => {
        const isOpen = e.target.classList.contains('is-open');
        const target = e.target.getAttribute('aria-controls');
        const targetEl = document.getElementById(target);
        if(isOpen) {
          e.target.classList.remove('is-open');
          e.target.setAttribute('aria-expanded', 'false');
          targetEl.classList.remove('is-open');
        } else {
          e.target.classList.add('is-open');
          e.target.setAttribute('aria-expanded', 'true');
          targetEl.classList.add('is-open');
        }
      })
    })
  }

  // Open linked FAQ categories/questions before scrolling to their anchors.
  const openFaqFromHash = () => {
    if (!window.location.hash) return;

    let anchorId;
    try {
      anchorId = decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return;
    }

    const target = document.getElementById(anchorId);
    if (!target || !target.matches('[data-faq-anchor]')) return;

    const parent = target.matches('[data-faq-search-parent]')
      ? target
      : target.closest('[data-faq-search-parent]');
    const parentTrigger = parent?.querySelector('[data-faq-search-parent-btn]');

    if (parentTrigger && !parentTrigger.classList.contains('is-open')) {
      parentTrigger.click();
    }

    if (target.matches('[data-faq-search]')) {
      const questionTrigger = target.querySelector('.collapsible-trigger');
      if (questionTrigger && !questionTrigger.classList.contains('is-open')) {
        questionTrigger.click();
      }
    }

    window.setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  openFaqFromHash();
  window.addEventListener('hashchange', openFaqFromHash);

  // FAQ Search
  const faqSearchInputs = document.querySelectorAll('[data-search-faqs-value]');
  if(faqSearchInputs) {
    faqSearchInputs.forEach(input => {
      input.addEventListener('input', function(e) {
        const searchQuery = this.value.toLowerCase();
        const onInput = debounce(getFaqSearchResults, 1000);
        onInput(searchQuery);
      })
    })
  }

  const getFaqSearchResults = (query) => {
    const parents = document.querySelectorAll('[data-faq-search-parent]');
    const faqItems = document.querySelectorAll('[data-faq-search]');
    const noResultsEl = document.querySelector('[data-search-faqs-no-results]');
    if(query) {
      faqItems.forEach(item => {
        const text = item.textContent.toLowerCase();
        if (text.includes(query)) {
          item.classList.remove('hide');
          item.classList.add('search-visible');
        } else {
          item.classList.add('hide');
          item.classList.remove('search-visible');
        }
      })
      
      parents.forEach(item => {
        const activeSearchResults = item.querySelectorAll('.search-visible');
        if(activeSearchResults.length) {
          item.classList.remove('hide');
          item.querySelector('[data-faq-search-parent-btn]:not(.is-open)')?.click();
        } else {
          item.classList.add('hide');
          item.querySelector('[data-faq-search-parent-btn].is-open')?.click();
        }
      })

      const activeResults = document.querySelectorAll('.search-visible');    
      if(activeResults.length) {
        noResultsEl.classList.add('hide');
      } else {
        noResultsEl.classList.remove('hide');
      }
    } else {
      parents.forEach(item => {
        item.classList.remove('hide');
        item.querySelector('[data-faq-search-parent-btn].is-open')?.click();
      })
      noResultsEl.classList.add('hide');
    }
  }

  $(document).on('click', '#yotpo-pdp-stars', (e) => {
    if(isMobile()) {
      const reviewsElement = document.querySelector('#yopto-reviews-widget-mobile');
      if(reviewsElement) {
        const reviewTab = document.querySelector('.collapsible-trigger[aria-controls="Product-content-yotpo-pdp-mobile-tab"]');
        if(reviewTab.getAttribute('aria-expanded') == "false") {
          reviewTab.click();
        }
        reviewsElement.scrollIntoView({ behavior: "smooth"});
      }
    } else {
      const reviewsElement = document.querySelector('#yopto-reviews-widget-desktop');
      if(reviewsElement) {
        reviewsElement.scrollIntoView({ behavior: "smooth"});
      }
    }
  })

  // PDP Description Read More (line clamp + gradient expand)
  initBlogTagBars();
  initCustomPdpTabs();
  initOkendoResponsiveLinks();
  initPdpDescriptionReadMore();

  window.addEventListener(
    'resize',
    debounce(() => {
      document.querySelectorAll('.description-read-more-outer:not(.description-read-more-outer--expanded)').forEach(outer => {
        const box = outer.querySelector('.description-read-more');
        if (!box) return;
        box.classList.remove('description-read-more--clamp');
        requestAnimationFrame(() => measureDescriptionReadMore(outer));
      });
    }, 200)
  );

}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', event => initBlogTagBars(event.target));

class cartUpsell extends HTMLElement {
  constructor(){
    super();
    this.slider = this.querySelector('.cart-upsell-slider');
    this.initSlider();
  }

  initSlider() {
    initCustomSlider(this.slider);
    if (window.AOS) { AOS.refreshHard() }
    document.dispatchEvent(new CustomEvent("cartupsell:loaded"));
  }
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', cartUpsell);
}


class StoreStatus extends HTMLElement {
  constructor(){
    super();

    this.script = this.querySelector('script');
    this.data = this.script ? JSON.parse(this.script.innerText) : null;
    if (!this.data) return;

    this.statusDiv = this.querySelector('[data-current-store-status]');
    this.isStoreLocatorPage = this.hasAttribute('data-store-locator');
    this.currentDayHours;
    this.openTime;
    this.closeTime;
    this.currentTime;
    this.currentDay;
    this.init();
  }

  init() {
    const timezone = this.data.timezone;
    this.currentDay = new Date().toLocaleString("en-GB", {timeZone: timezone, weekday: 'long' });
    this.currentTime = new Date().toLocaleString("en-GB", {timeZone: timezone, hour: '2-digit', minute:'2-digit'});
    this.currentDayHours = this.data.trading_hours[this.currentDay];
    
    this.checkOpen();
  }

  checkOpen() {
    if(this.currentDayHours) {
      const tradingTimeSplit = this.currentDayHours.replaceAll(' ','').split('-');
      const timeToNumber = parseInt(this.currentTime.replace(':', ''));
      this.openTime = tradingTimeSplit[0];
      this.closeTime = tradingTimeSplit[1];
      const openTimeToNumber = parseInt(this.openTime.replace(':', ''));
      const closeTimeToNumber = parseInt(this.closeTime.replace(':', ''));
      if(timeToNumber >= openTimeToNumber && timeToNumber < closeTimeToNumber) {
        this.storeOpen(this.closeTime);
      } else {
        if(timeToNumber < openTimeToNumber) {
          this.storeClosed(true);
        } else {
          this.storeClosed(false);
        }
      }

    } else {
      this.storeClosed(false);
    }
  }

  storeClosed(openToday) {
    if(openToday) {
      let openTime = this.convertTime(this.openTime);
      if (openTime.charAt(0) == '0') {
        openTime = openTime.slice(1)
      }
      if(this.isStoreLocatorPage) {
        this.statusDiv.innerHTML = `
          <div class="store-status__box store-status--bold store-status--closed"><div class="bullet bullet--closed">&#8226;</div>Closed</div>
          <div>Opens at ${openTime}</div>
        `;
      } else {
        // this.statusDiv.innerHTML = '<strong>Closed</strong> Opens: ' + openTime;
        this.statusDiv.innerHTML = '<span class="dot--red"></span><strong>Closed</strong>';
      }
    } else {
      const nextOpens = this.nextOpen();
      
      if(this.isStoreLocatorPage) {
        this.statusDiv.innerHTML = `
          <div class="store-status__box store-status--bold store-status--closed"><div class="bullet bullet--closed">&#8226;</div>Closed Now</div>
          <div>Opens ${nextOpens[0]}, ${nextOpens[1].charAt(0) == '0' ? nextOpens[1].slice(1) : nextOpens[1]}</div>
        `;
      }
    }
  }

  storeOpen() {
    const closeTime = this.convertTime(this.closeTime);
    if(this.isStoreLocatorPage) {
      this.statusDiv.innerHTML = `
        <div class="store-status__box store-status--bold store-status--open"><div class="bullet bullet--open">&#8226;</div><div>Open Now</div></div>
        <div>Closes at ${closeTime}</div>
      `;
    } else {
      // this.statusDiv.innerHTML = `<strong>Open Now</strong> Closes: ${closeTime}`;
      this.statusDiv.innerHTML = `<span class="dot--green"></span><span>Open Now</span>`;
    }
  }

  convertTime(time) {
    const timeSplit = time.split(':');
    let newTime = timeSplit[0];
    let ampm = 'AM';
    if(parseInt(timeSplit[0]) >= 12) {
      newTime = parseInt(timeSplit[0]) - 12;
      ampm = 'PM';
    }
    return newTime + ':' + timeSplit[1] + ampm;
  }

  nextOpen() {
    const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
    const dayIndex = days.indexOf(this.currentDay);
    const newDayOrder = days.slice(dayIndex+1).concat(days.slice(0, dayIndex+1));
    let openTime;
    let day;
    for(let i=0;i<newDayOrder.length;i++) {
      const tradingHours = this.data.trading_hours[newDayOrder[i]];
      if(tradingHours) {
        openTime = tradingHours.replaceAll(' ','').split('-')[0];
        if(i === 0) {
          day = 'tomorrow'
        } else {
          day = newDayOrder[i];
        }
        break;
      }
    }
    return [day, this.convertTime(openTime)];

  }

}

if (!customElements.get('store-status')) {
  customElements.define('store-status', StoreStatus);
}

window.addEventListener('DOMContentLoaded', () => {
  const toggleBtns = document.querySelectorAll('.store-page__buttons .btn--toggle');
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const action = btn.getAttribute('data-action'); // 'map' or 'image'

      const imgs = document.querySelectorAll('.store-page__banner-image-wrapper .banner-image');
      const maps = document.querySelectorAll('.store-page__banner-image-wrapper .banner-map');

      if (action == 'image' && imgs && maps) {
        imgs.forEach(img => {
          img.classList.add('active');
        })
        maps.forEach(map => {
          map.classList.remove('active');
        })

        toggleBtns.forEach(btn2 => {
          btn2.setAttribute('data-action', 'map');
          btn2.innerHTML = "Map";
        })
      }
      if (action == 'map' && imgs && maps) {
        imgs.forEach(img => {
          img.classList.remove('active');
        })
        maps.forEach(map => {
          map.classList.add('active');
        })

        toggleBtns.forEach(btn2 => {
          btn2.setAttribute('data-action', 'image');
          btn2.innerHTML = "Image";
        })
      }
    })
  })

  const listingPageToggleBtns = document.querySelectorAll('.section--store-locator .map-toggle-btn');
  listingPageToggleBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      listingPageToggleBtns.forEach(btn2 => {
        btn2.classList.remove('active');
      })
      btn.classList.add('active');

      const action = btn.getAttribute('data-action'); // 'map' or 'list'

      const map = document.querySelector('.section--store-locator .banner-map');
      if (action == 'map' && map) {
        map.classList.add('active');
        const allStoresBtn = document.querySelector('.store-locator__city-btn[value="All Stores"]');
        if (allStoresBtn) {
          allStoresBtn.click();
        }
        const searchInput = document.querySelector('.store-locator__search-wrapper input');
        if (searchInput) {
          searchInput.value = "";
        }
      }
      if (action == 'list' && map) {
        map.classList.remove('active');
        map.classList.remove('desktop-active');
      }

      const searchWrapper = document.querySelector('.section--store-locator .store-locator__search-wrapper');
      const stateSelectWrapper = document.querySelector('.section--store-locator .store-locator__state-select');
      if (action == 'map' && searchWrapper && stateSelectWrapper) {
        searchWrapper.classList.add('active');
        stateSelectWrapper.classList.remove('active');
      }
      if (action == 'list' && searchWrapper && stateSelectWrapper) {
        searchWrapper.classList.remove('active');
        searchWrapper.classList.remove('desktop-active');
        stateSelectWrapper.classList.add('active');
      }
    })

  })
})

// Searchspring
window.addEventListener('searchspring.domReady', (e) => {
  console.log('searchspring.domReady');
})

window.addEventListener('searchspringCarousel.domReady', (e) => {
  console.log('searchspringCarousel.domReady');
})

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    }
    else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
          return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}

function setTopProperty() {
  var headerHeight = document.querySelector('.site-header').offsetHeight;
  const ssAutocomplete = document.querySelector('.ss__autocomplete--target.ss__autocomplete--default');
  if(ssAutocomplete) {
    ssAutocomplete.style.top = headerHeight + 'px';
  }
}

waitForElementToDisplay(".ss__autocomplete--target.ss__autocomplete--default",setTopProperty,1000,9000);

// End Searchspring

// Start loop returns
const hideLoopBar = () => {
  const loopBar = document.querySelector('#loop-onstore');
  if (!loopBar) return;

  loopBar.classList.add('hidden');
}
const showLoopBar = () => {
  const loopBar = document.querySelector('#loop-onstore');
  if (!loopBar) return;

  loopBar.classList.remove('hidden');
}
document.addEventListener('drawerOpen', (e) => {
  hideLoopBar();
})
document.addEventListener('drawerClose', (e) => {
  showLoopBar();
})
// End loop returns

// Start PDP Complete The Look
$(document).on('change', '.complete-the-look__product-variant-select', (e) => {
  const select = e.currentTarget;

  const parent = select.closest('.complete-the-look__product');

  const selectedVariantID = select.options[select.selectedIndex].value;
  if (!selectedVariantID) return;

  const selectedVariantPrice = select.options[select.selectedIndex].getAttribute('data-price');
  const selectedVariantComparePrice = select.options[select.selectedIndex].getAttribute('data-compare-price');
  const selectedVariantSavedAmount = select.options[select.selectedIndex].getAttribute('data-saved-amount');
  if (selectedVariantPrice) {
      const priceElem = parent.querySelector('.complete-the-look__product-price');
      if (priceElem) {
        let priceHtml = selectedVariantPrice + (Shopify.currency.active == 'USD' ? 'USD' : '');
        if(selectedVariantComparePrice) {
          priceHtml += '<span class="complete-the-look__product-price--original">' + selectedVariantComparePrice + (Shopify.currency.active == 'USD' ? ' USD' : '') + '</span>';
        }
        if(selectedVariantSavedAmount) {
          priceHtml += '<span class="complete-the-look__product-price--savings">Save ' + selectedVariantSavedAmount + '</span>';
        }
        priceElem.innerHTML = priceHtml;
      }
  }

  const atcButton = parent.querySelector('.complete-the-look__product-atc');
  if (atcButton) {
      atcButton.setAttribute('data-variant', selectedVariantID);
      atcButton.disabled = false;
      atcButton.textContent = 'Add';
  }
})

$(document).on('click', '.complete-the-look__product-atc', (e) => {
  const btn = e.currentTarget;
  btn.classList.add('btn--loading');

  const variantID = btn.getAttribute('data-variant');
  if (!variantID) return;

  const data = {
      "id": variantID,
      "quantity": 1
  }

  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: async function() { 
          const cart = await theme.cart.getCart();
          document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart }
          }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
      },
      complete: function() {
        btn.classList.remove('btn--loading');
      }
  });
})
// End PDP Complete The Look

// Start shoppable lookbook
class ShoppableLookbook extends HTMLElement {
  constructor() {
    super();

    this.drawerId = this.dataset.drawerId;
    this.drawerName = this.dataset.drawerName;
    this.triggers = this.querySelectorAll('[data-lookbook-trigger]');
    this.panels = this.querySelectorAll('[data-lookbook-panel]');

    if (this.drawerId && this.drawerName && window.theme && theme.Drawers) {
      this.drawer = new theme.Drawers(this.drawerId, this.drawerName);
    }

    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        this.showPanel(e.currentTarget.dataset.lookbookTrigger);
      });
    });

    document.addEventListener('shopify:block:select', (e) => {
      const blockId = e.detail.blockId;
      const panel = this.querySelector(`[data-lookbook-panel="${blockId}"]`);
      if (panel) {
        this.showPanel(blockId);
      }
    });
  }

  showPanel(id) {
    this.panels.forEach(panel => {
      panel.classList.toggle('is-active', panel.dataset.lookbookPanel === id);
    });
  }
}

if (!customElements.get('shoppable-lookbook')) {
  customElements.define('shoppable-lookbook', ShoppableLookbook);
}
// End shoppable lookbook

// PLP Custom Wishlist remove from wishlist if has variant wishlisted
function closeCollectionWishlistDropdowns(exceptWrapper) {
  document.querySelectorAll('.custom-wishlist-button-wrapper.show-dropdown').forEach(wrapper => {
    if(wrapper === exceptWrapper) return;

    wrapper.classList.remove('show-dropdown');
    const btn = wrapper.querySelector('.custom-wishlist-button');
    if(btn) {
      btn.setAttribute('aria-expanded', 'false');
    }
  });
}

$(document).on('click', '.custom-wishlist-button', (e) => {
  e.preventDefault();
  e.stopPropagation();

  const btn = e.currentTarget;
  const parent = btn.closest('.custom-wishlist-button-wrapper');
  const hasActive = parent.querySelector('.swym-added');

  if(hasActive) {
    hasActive.click();
    parent.classList.remove('hide-dropdown');
    parent.classList.remove('show-dropdown');
    btn.setAttribute('aria-expanded', 'false');
  } else if(window.matchMedia('(max-width: 768px)').matches) {
    const shouldOpen = !parent.classList.contains('show-dropdown');

    closeCollectionWishlistDropdowns(parent);

    parent.classList.remove('hide-dropdown');
    parent.classList.toggle('show-dropdown', shouldOpen);
    btn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  } else {
    parent.classList.add('hide-dropdown');
  }
})

$(document).on('click', '.custom-wishlist-variant-list .swym-button--custom-variant', (e) => {
  const parent = e.currentTarget.closest('.custom-wishlist-button-wrapper');
  if(!parent) return;

  parent.classList.remove('show-dropdown');
  const btn = parent.querySelector('.custom-wishlist-button');
  if(btn) {
    btn.setAttribute('aria-expanded', 'false');
  }
})

document.addEventListener('pointerdown', (e) => {
  const clickedWrapper = e.target.closest('.custom-wishlist-button-wrapper');
  closeCollectionWishlistDropdowns(clickedWrapper);
}, true);

$(document).on('mouseleave', '.custom-wishlist-button-wrapper', (e) => {
  e.currentTarget.classList.remove('hide-dropdown');
})
